<template>
  <tr v-if="item">
    <td>
      <div class="row">
        <div
          class="col-3"
          style="display: flex; align-items: center;">
          <img
            :src="item.imageUrl"
            class="img-fluid"
            style="max-height: 14em; object-fit: contain; margin: 0 auto; padding: 10px;"
            @error="imgError">
        </div>
        <div class="col-9 position-relative">
          <DisplayAction
            class="float-end"
            :record="record"
            :customer="customer"
            :item="item"/>
          <strong>{{ item.name }}</strong>
          <ul
            class="px-0 pb-2"
            style="list-style-type: none;">
            <li>Priceline: {{ item.priceLine }}</li>
            <!-- <li>Product ID: {{ item.eclipseId }}</li> -->
            <li>Type: {{ item.merchandisingType }}</li>
            <li>Collection: {{ item.collection }}</li>
          </ul>
          <small
            class="text-muted"
            style="position: absolute;right: 15px;bottom: 0px;">
            Date Placed: {{ moment(record.datePlaced).format('DD-MM-YYYY') }}
          </small>
        </div>
      </div>
    </td>
  </tr>
</template>

<script setup>
  import comingSoon from '../../../../../../../../shared/comingSoon';
  import DisplayAction from '../../../components/DisplayAction.vue';

  // Initialize
  const props = defineProps(['record', 'item', 'customer'])
  
  // Methods
  const imgError = (e)=>{
    return comingSoon(e)
  }
</script>